import routes from "src/routes"

const formatMissionType = (type) => {
  switch (type) {
    case "watch_video":
      return "Promotional videos"
    case "drop_namecard":
      return "Drop Name Cards"
    case "download_pdf":
      return "PDF brochures"
    case "image_gallery":
      return "Image Gallery"
    case "check_company_info":
      return "Company Info"
    default:
      return ""
  }
}

const pointerButton = (type) => {
  switch (type) {
    case "watch_video":
      return "tv"
    case "check_company_info":
      return "info"
    case "image_gallery":
      return "wp"
    case "download_pdf":
      return "pdf"
    case "drop_namecard":
      return "namecard"
    default:
      return ""
  }
}
const mobilePointer = (type) => {
  switch (type) {
    case "watch_video":
      return `
        top: 50%;
        left: 0%;
      `
    case "check_company_info":
      return `
        top: 50%;
        left: 48%;
      `
    case "image_gallery":
      return  `
        top: 50%;
        left: 33%;
      `
    case "download_pdf":
      return  `
        top: 50%;
        left: 20%;
      `
    case "drop_namecard":
      return  `
        top: 50%;
        left: 70%;
      `
    default:
      return ""
  }
}
const getMissionRoute = (taskName) => {
  switch (taskName) {
    case "auditorium_a":
      return routes.auditorium1
    case "auditorium_b":
      return routes.auditorium2
    case "satellite":
      return "/on-demand/satellite"
    case "short_talk":
      return "/on-demand/short-talk"  
    default:
      return ""
  }
}

export { formatMissionType, pointerButton, mobilePointer, getMissionRoute }